import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface StaticAuthCardProps {
  title: string;
  description: string;
  children: ReactNode;
  className?: string;
}

export function StaticAuthCard({ 
  title, 
  description, 
  children, 
  className 
}: StaticAuthCardProps) {
  return (
    <div className={cn(
      "w-full min-w-[400px] min-h-0 rounded-xl border bg-card text-card-foreground shadow-lg",
      className
    )}>
      <div className="flex flex-col space-y-2 p-8 pb-6 sm:p-10 sm:pb-8">
        <h1 className="text-2xl font-bold text-center tracking-tight sm:text-3xl lg:text-4xl">
          {title}
        </h1>
        <p className="text-base text-muted-foreground text-center sm:text-lg">
          {description}
        </p>
      </div>
      <div className="p-8 pt-0 sm:p-10 sm:pt-0">
        {children}
      </div>
    </div>
  );
} 